import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { roleList, kindList, squidTypeList } from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Descriptions,
    Card,
    Form,
    Tag,
    Modal,
    Switch,
    Select,
    Button,
    DatePicker,
    Empty,
    Pagination,
    InputNumber,
    Statistic,
    Dropdown,
    Menu,
    Icon,
    Spin,
    Tabs,
    notification
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import HandDetailOfc from "@/pages/commom/HandDetailOfc";
let timer
let key = `open${Date.now()}`;
export default class PlayerDetail extends React.Component {
    state = {
        handCardMid: undefined, // 手牌详情id
        handCardUrl: undefined, // 手牌详情地址
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        showClubOtherInfo: false, // 是否显示俱乐部其他信息弹窗
        showDetail: false, // 是否显示手牌弹窗
        loading: false, // 是否加载中
        gameLoading: false, // 游戏数据是否加载中
        integralLoading: false, // 积分记录是否加载中
        diamondLoading: false, // 钻石记录是否加载中
        counterDiamondLoading: false, // 柜台钻石记录是否加载中
        loginLoading: false, // 登录记录是否加载中
        operateLoading: false, // 操作记录是否加载中
        roundLoading: false, // 牌局记录是否加载中
        detailLoading: false, // 手牌详情是否加载中
        dataRecordExportLoading: false, // 数据记录导出是否加载中
        gambleRecordExportLoading: false, // 牌局记录导出是否加载中
        gameQueryParams: {
            // 游戏数据查询参数
            date: [],
            kind: undefined,
        },
        integralQueryParams: {
            // 积分记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: undefined,
        },
        diamondQueryParams: {
            // 钻石记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: undefined,
        },
        counterDiamondQueryParams: {
            // 柜台钻石记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: undefined,
        },
        loginQueryParams: {
            // 登录记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: undefined,
        },
        operateQueryParams: {
            // 操作记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
        },
        roundQueryParams: {
            // 牌局记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
            game_kind: 1,
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            tid: undefined,
            mid: undefined,
            uid: undefined,
        },
        formData: {
            // 表单数据
            no_day_limit: undefined,
            no_week_limit: undefined,
            day_limit: undefined,
            week_limit: undefined,
            add_day_left: undefined,
            add_week_left: undefined,
        },
        squidTypeList: squidTypeList, // 鱿鱼模式
        roleList: roleList, // 角色列表,
        kindList: kindList, // 游戏列表
        playerInfo: {}, // 玩家信息
        handCardConfig: {}, // 牌局配置
        tableList: [], // 牌座列表
        selectedData: {}, // 选中的表格数据
        gameData: [], // 游戏数据
        integralData: [], // 积分记录
        diamondData: [], // 钻石记录
        counterDiamondData: [], // 柜台钻石记录
        loginData: [], // 登录记录
        operateData: [], // 操作记录
        roundData: [], // 牌局记录
        handCardData: {}, // 手牌数据
    };

    async componentDidMount () {
        await this.fetchPlayerInfo();
        this.fetchGameData();
        this.fetchIntegralData();
        this.fetchDiamondData();
        this.fetchCounterDiamondData();
        this.fetchLoginData();
        this.fetchOperateData();
        this.fetchRoundData();
    }

    componentDidUpdate (prevProps) {
        // 监听url变化
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.location.reload();
        }
    }

    /**
     * 获取玩家信息
     */
    fetchPlayerInfo = async () => {
        this.setState({ loading: true });
        let res = await axios.get("/v1/api/union_club_user_detail", {
            params: {
                club_id: this.props.match.params.club_id,
                user_id: this.props.match.params.user_id,
            },
        });
        this.setState({
            loading: false,
            gameQueryParams: {
                ...this.state.gameQueryParams,
                kind: res.data && res.data.level === 1 ? 1 : 0,
            },
            integralQueryParams: {
                ...this.state.integralQueryParams,
                kind: res.data && res.data.level === 1 ? 1 : 0,
            },
            playerInfo: res.data || {},
            handCardConfig: res.data && res.data.block_game_conf ? res.data.block_game_conf : {},
        });
    };

    /**
     * 获取游戏数据
     */
    fetchGameData = () => {
        this.setState({ gameLoading: true });
        axios
            .get("/v1/api/union_club_user_statistic", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    kind: this.state.gameQueryParams.kind,
                    begin_time:
                        this.state.gameQueryParams.date[0] &&
                        this.state.gameQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.gameQueryParams.date[1] &&
                        this.state.gameQueryParams.date[1].startOf("day").valueOf() / 1000,
                },
            })
            .then((res) => {
                this.setState({
                    gameLoading: false,
                    gameData: res.data ? [res.data] : [],
                });
            });
    };

    /**
     * 获取积分记录
     */
    fetchIntegralData = () => {
        this.setState({ integralLoading: true });
        axios
            .get("/v1/api/union_club_user_point_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    ...this.state.integralQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    integralLoading: false,
                    integralQueryParams: {
                        ...this.state.integralQueryParams,
                        total: res.count || 0,
                    },
                    integralData: res.data || [],
                });
            });
    };

    /**
     * 获取钻石记录
     */
    fetchDiamondData = () => {
        this.setState({ diamondLoading: true });
        axios
            .get("/v1/api/union_club_user_diamond_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    ...this.state.diamondQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    diamondLoading: false,
                    diamondQueryParams: {
                        ...this.state.diamondQueryParams,
                        total: res.count || 0,
                    },
                    diamondData: res.data || [],
                });
            });
    };

    /**
     * 获取柜台钻石记录
     */
    fetchCounterDiamondData = () => {
        this.setState({ counterDiamondLoading: true });
        axios
            .get("/v1/api/union_club_user_account_diamond_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    ...this.state.counterDiamondQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    counterDiamondLoading: false,
                    counterDiamondQueryParams: {
                        ...this.state.counterDiamondQueryParams,
                        total: res.count || 0,
                    },
                    counterDiamondData: res.data || [],
                });
            });
    };

    /**
     * 获取登录记录
     */
    fetchLoginData = () => {
        this.setState({ loginLoading: true });
        axios
            .get("/v1/api/union_club_user_login_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    ...this.state.loginQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loginLoading: false,
                    loginQueryParams: {
                        ...this.state.loginQueryParams,
                        total: res.count || 0,
                    },
                    loginData: res.data || [],
                });
            });
    };

    /**
     * 获取操作记录
     */
    fetchOperateData = () => {
        this.setState({ operateLoading: true });
        axios
            .get("/v1/api/union_club_user_op_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    uid: this.props.match.params.user_id,
                    ...this.state.operateQueryParams,
                    begin_time:
                        this.state.operateQueryParams.date[0] &&
                        this.state.operateQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.operateQueryParams.date[1] &&
                        this.state.operateQueryParams.date[1].startOf("day").valueOf() / 1000,
                    date: [],
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    operateLoading: false,
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        total: res.count || 0,
                    },
                    operateData: res.data || [],
                });
            });
    };

    /**
     * 获取牌局记录
     */
    fetchRoundData = () => {
        this.setState({ roundLoading: true });
        axios
            .get("/v1/api/union_club_user_game_log", {
                params: {
                    club_id: this.props.match.params.club_id,
                    user_id: this.props.match.params.user_id,
                    ...this.state.roundQueryParams,
                    begin_time:
                        this.state.roundQueryParams.date[0] &&
                        this.state.roundQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.roundQueryParams.date[1] &&
                        this.state.roundQueryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: [],
                },
            })
            .then((res) => {
                this.setState({
                    roundLoading: false,
                    roundQueryParams: {
                        ...this.state.roundQueryParams,
                        total: res.count || 0,
                    },
                    roundData:
                        this.state.roundQueryParams.game_kind === 3
                            ? res.data
                                ? [res.data]
                                : []
                            : res.data || [],
                });
            });
    };

    /**
     * 获取牌桌列表
     */
    fetchTableList = () => {
        axios
            .get("/v1/api/mtt/match/tables", {
                params: {
                    mid: this.state.detailQueryParams.mid,
                },
            })
            .then((res) => {
                this.setState({
                    tableList: res.data || [],
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        tid: res.data && res.data[0] ? res.data[0].tid : undefined,
                    },
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(
                this.state.roundQueryParams.game_kind === 5
                    ? "/v1/api/mtt/hand/detail"
                    : "/v1/api/union_game_detail",
                {
                    params: {
                        ...this.state.detailQueryParams,
                        total: undefined,
                    },
                }
            )
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData:
                        this.state.roundQueryParams.game_kind === 5
                            ? res.data
                                ? res.data[0]
                                : {}
                            : res.data || {},
                });
            });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.type === "sendJetton" ||
                    this.state.type === "recycleJetton"
                ) {
                    // 发放、回收筹码
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendJetton"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.playerInfo.user_id),
                            club: Number(this.state.playerInfo.club_id),
                            kind: 1,
                            level: this.state.playerInfo.level,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchPlayerInfo();
                            }
                        });
                } else if (
                    this.state.type === "sendIntegral" ||
                    this.state.type === "recycleIntegral"
                ) {
                    // 发放、回收积分
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendIntegral"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.playerInfo.user_id),
                            club: Number(this.state.playerInfo.club_id),
                            kind: 0,
                            level: this.state.playerInfo.level,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchPlayerInfo();
                            }
                        });
                } else if (
                    this.state.type === "sendDiamond" ||
                    this.state.type === "recycleDiamond"
                ) {
                    // 发放、回收钻石
                    let url;
                    if (Cookie.get("unionType") === "super_union") {
                        if (this.state.playerInfo.level === 1) {
                            // 超盟转玩家
                            url = "/v1/api/diamond/super_union/user";
                        } else if (this.state.playerInfo.level !== 100) {
                            // 超盟转非玩家
                            url = "/v1/api/diamond/super_union/agent";
                        }
                    } else {
                        if (this.state.playerInfo.level === 1) {
                            // 联盟盟转玩家
                            url = "/v1/api/diamond/union/user";
                        } else if (this.state.playerInfo.level !== 100) {
                            // 联盟转非玩家
                            url = "/v1/api/diamond/union/agent";
                        }
                    }
                    axios
                        .patch(url, {
                            amount:
                                this.state.type === "sendDiamond"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.playerInfo.user_id),
                            club: Number(this.state.playerInfo.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchPlayerInfo();
                            }
                        });
                } else if (this.state.type === "editLossLimit") {
                    // 编辑亏损限额
                    axios
                        .patch("/v1/api/union_club_user_loss_limit", {
                            club_id: this.state.playerInfo.club_id,
                            user_id: this.state.playerInfo.user_id,
                            no_day_limit: !values.no_day_limit,
                            no_week_limit: !values.no_week_limit,
                            day_limit: Number(values.day_limit),
                            week_limit: Number(values.week_limit),
                            add_day_left: Number(values.add_day_left),
                            add_week_left: Number(values.add_week_left),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchPlayerInfo();
                            }
                        });
                } else if (this.state.type === "exportDataRecord") {
                    // 获取导出的数据记录路径key
                    axios
                        .get('/v1/api/export_union_club_user_all_log_list', {
                            params: {
                                user_id: this.state.playerInfo.user_id,
                                club_id: this.state.playerInfo.club_id,
                                begin_time: values.date[0] && values.date[0].startOf("day").valueOf() / 1000,
                                end_time: values.date[1] && values.date[1].startOf("day").valueOf() / 1000,
                            }
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                this.handleClose();
                                notification.open({
                                    key,
                                    duration: 0,
                                    message: this.props.language["hint"],
                                    description: this.props.language["exportLoaddingMessage"],
                                    icon: <Icon type="loading" style={{ color: '#108ee9' }} />,
                                    onClose: () => {
                                        if (timer) clearInterval(timer);
                                        timer = undefined;
                                        this.setState({ dataRecordExportLoading: false });
                                    }
                                });
                                if (!timer) {
                                    this.handleExportDataRecord(res.file_id);
                                    timer = setInterval(() => {
                                        this.handleExportDataRecord(res.file_id);
                                    }, 2000);
                                }
                            }
                        });
                }
            }
        });
    };

    /**
     * 根据key进行导出数据记录
     */
    handleExportDataRecord = (file_id) => {
        this.setState({ dataRecordExportLoading: true });
        axios.get('/v1/api/get_export_union_club_user_all_log_list_url', {
            params: {
                file_id,
            },
        })
            .then((res) => {
                if (res.url) {
                    notification.close(key);
                    if (timer) clearInterval(timer);
                    timer = undefined;
                    this.setState({ dataRecordExportLoading: false });
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    }

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === "sendJetton") {
            this.setState({
                show: true,
                type,
                title: this.props.language["sendChip"],
            });
        } else if (type === "recycleJetton") {
            this.setState({
                show: true,
                type,
                title: this.props.language["recycleChip"],
            });
        } else if (type === "sendIntegral") {
            this.setState({
                show: true,
                type,
                title: this.props.language["sendIntergral"],
            });
        } else if (type === "recycleIntegral") {
            this.setState({
                show: true,
                type,
                title: this.props.language["recycleIntergral"],
            });
        } else if (type === "sendDiamond") {
            this.setState({
                show: true,
                type,
                title: this.props.language["sendDiamond"],
            });
        } else if (type === "recycleDiamond") {
            this.setState({
                show: true,
                type,
                title: this.props.language["recycleDiamond"],
            });
        } else if (type === "exportDataRecord") {
            this.setState({
                show: true,
                type,
                title: this.props.language["exportDataRecord"],
            });
        } else if (type === "editLossLimit") {
            this.setState({
                show: true,
                type,
                title: this.props.language["editLossLimit"],
                formData: {
                    no_day_limit: !this.state.playerInfo.loss_info.no_day_limit,
                    no_week_limit: !this.state.playerInfo.loss_info.no_week_limit,
                    day_limit: this.state.playerInfo.loss_info.day_loss_limit,
                    week_limit: this.state.playerInfo.loss_info.week_loss_limit,
                    add_day_left: this.state.playerInfo.loss_info.day_loss_quota,
                    add_week_left: this.state.playerInfo.loss_info.week_loss_quota,
                },
            });
        } else if (type === "underlineProxy") {
            this.setState({
                showClubOtherInfo: true,
                type,
                title: this.props.language["lowerProxy"],
            });
        } else if (type === "underlinePlayer") {
            this.setState({
                showClubOtherInfo: true,
                type,
                title: this.props.language["lowerPlayer"],
            });
        } else if (type === "proportion") {
            this.setState({
                showClubOtherInfo: true,
                type,
                title: this.props.language["proportionData"],
            });
        } else if (type === "handCard") {
            this.setState(
                {
                    type,
                    showDetail: true,
                    title: this.props.language["handDetail"],
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        mid: item.mid,
                        uid: undefined,
                    },
                },
                () => {
                    if (this.state.roundQueryParams.game_kind === 5)
                        this.fetchTableList();
                    this.fetchHandCardData();
                }
            );
        }
    };

    /**
     * 更新配置
     */
    handleUpdateConfig = (kind, level, value) => {
        axios
            .patch("/v1/api/union_club_user_game_block", {
                club_id: Number(this.props.match.params.club_id),
                user_id: Number(this.props.match.params.user_id),
                game_kind: kind,
                option_name: level,
                is_blocked: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["updateSuccessMessage"]);
                    this.fetchPlayerInfo();
                }
            });
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "game") {
            // 游戏数据
            this.setState(
                {
                    gameQueryParams: {
                        ...this.state.gameQueryParams,
                        [key]: value || (key === "kind" ? 0 : undefined),
                    },
                },
                () => this.fetchGameData()
            );
        } else if (type === "integral") {
            // 积分记录
            this.setState(
                {
                    integralQueryParams: {
                        ...this.state.integralQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchIntegralData()
            );
        } else if (type === "diamond") {
            // 钻石记录
            this.setState(
                {
                    diamondQueryParams: {
                        ...this.state.diamondQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchDiamondData()
            );
        } else if (type === "counterDiamond") {
            // 柜台钻石记录
            this.setState(
                {
                    counterDiamondQueryParams: {
                        ...this.state.counterDiamondQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchCounterDiamondData()
            );
        } else if (type === "login") {
            // 登录记录
            this.setState(
                {
                    loginQueryParams: {
                        ...this.state.loginQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchLoginData()
            );
        } else if (type === "operate") {
            // 操作记录
            this.setState(
                {
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchOperateData()
            );
        } else if (type === "round") {
            // 牌局记录
            this.setState(
                {
                    roundQueryParams: {
                        ...this.state.roundQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchRoundData()
            );
        } else if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => {
                    this.fetchHandCardData();
                }
            );
        }
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "integral") {
            // 积分记录
            this.setState(
                {
                    integralQueryParams: {
                        ...this.state.integralQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchIntegralData()
            );
        } else if (type === "diamond") {
            // 钻石记录
            this.setState(
                {
                    diamondQueryParams: {
                        ...this.state.diamondQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchDiamondData()
            );
        } else if (type === "counterDiamond") {
            // 柜台钻石记录
            this.setState(
                {
                    counterDiamondQueryParams: {
                        ...this.state.counterDiamondQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchCounterDiamondData()
            );
        } else if (type === "login") {
            // 登录记录
            this.setState(
                {
                    loginQueryParams: {
                        ...this.state.loginQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchLoginData()
            );
        } else if (type === "operate") {
            // 操作记录
            this.setState(
                {
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchOperateData()
            );
        } else if (type === "round") {
            // 牌局记录
            this.setState(
                {
                    roundQueryParams: {
                        ...this.state.roundQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchRoundData()
            );
        } else if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false });
    };

    /**
     * 导出牌局记录
     */
    handleExportGambleRecord = () => {
        this.setState({ gambleRecordExportLoading: true });
        axios
            .get('/v1/api/export_union_club_user_game_log', {
                params: {
                    user_id: this.state.playerInfo.user_id,
                    club_id: this.state.playerInfo.club_id,
                    begin_time: this.state.roundQueryParams.date[0] && this.state.roundQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time: this.state.roundQueryParams.date[1] && this.state.roundQueryParams.date[1].startOf("day").valueOf() / 1000,
                },
            }
            )
            .then((res) => {
                this.setState({ gambleRecordExportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    render () {
        return (
            <Spin spinning={this.state.loading}>
                <div className='p10'>
                    <Row gutter={10}>
                        {/* 左侧 */}
                        <Col span={isMobileDevice() ? 24 : 12}>
                            {/* 玩家信息 */}
                            <Card
                                title={
                                    <h2>{this.props.language["playerInfo"]}</h2>
                                }
                                type="inner"
                            >
                                <Descriptions size="small" column={1}>
                                    <Descriptions.Item label={this.props.language["playerId"]}>
                                        {this.state.playerInfo.user_id}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["playerName"]}>
                                        {this.state.playerInfo.user_name}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["registerChannel"]}>
                                        {this.state.playerInfo.register_channel}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["registerTime"]}>
                                        {this.state.playerInfo.register_time}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["lastLoginTime"]}>
                                        {this.state.playerInfo.last_login_at}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={this.props.language["lastPlayCardTime"]}>
                                        {this.state.playerInfo.last_play_at}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>

                            {/* 余额 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>{this.props.language["balance"]}</h2>
                                        {(Cookie.get("identityType") === "super_union" ||
                                            Cookie.get("identityType") === "union") &&
                                            this.state.playerInfo.level === 1 && (
                                                <Button
                                                    className=" ml10"
                                                    type="danger"
                                                    ghost
                                                    onClick={() => this.handleShow("sendDiamond")}
                                                >
                                                    {this.props.language["sendDiamond"]}
                                                </Button>
                                            )}
                                    </Row>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    {/* 玩家钻石 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(
                                                        this.state.playerInfo.wallet_diamond || 0
                                                    )}
                                                />
                                                <p className="label">
                                                    {this.props.language["playerDiamnd"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 俱乐部信息 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>{this.props.language["clubInfo"]}</h2>
                                        {(Cookie.get("identityType") === "super_union" ||
                                            Cookie.get("identityType") === "union") && (
                                                <Dropdown
                                                    trigger={['click']}
                                                    overlay={
                                                        <Menu
                                                            onClick={({ key }) =>
                                                                this.handleShow(key, this.state.playerInfo)
                                                            }
                                                        >
                                                            <Menu.Item key="sendJetton">
                                                                {this.props.language["sendChip"]}
                                                            </Menu.Item>
                                                            <Menu.Item key="recycleJetton">
                                                                {this.props.language["recycleChip"]}
                                                            </Menu.Item>
                                                            {this.state.playerInfo.level !== 1 &&
                                                                this.state.playerInfo.level !== 100 && (
                                                                    <Menu.Item key="sendIntegral">
                                                                        {this.props.language["sendIntergral"]}
                                                                    </Menu.Item>
                                                                )}
                                                            {this.state.playerInfo.level !== 1 &&
                                                                this.state.playerInfo.level !== 100 && (
                                                                    <Menu.Item key="recycleIntegral">
                                                                        {this.props.language["recycleIntergral"]}
                                                                    </Menu.Item>
                                                                )}
                                                            {this.state.playerInfo.level !== 1 &&
                                                                this.state.playerInfo.level !== 100 && (
                                                                    <Menu.Item key="sendDiamond">
                                                                        {this.props.language["sendDiamond"]}
                                                                    </Menu.Item>
                                                                )}
                                                            {this.state.playerInfo.level !== 1 &&
                                                                this.state.playerInfo.level !== 100 && (
                                                                    <Menu.Item key="recycleDiamond">
                                                                        {this.props.language["recycleDiamond"]}
                                                                    </Menu.Item>
                                                                )}
                                                        </Menu>
                                                    }
                                                >
                                                    <Button type="primary" ghost>
                                                        {this.props.language["operation"]}
                                                        <Icon type="down" />
                                                    </Button>
                                                </Dropdown>
                                            )}
                                    </Row>
                                }
                                type="inner"
                            >
                                <Table
                                    dataSource={[this.state.playerInfo]}
                                    pagination={false}
                                    loading={this.state.loading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                    bordered
                                    size="small"
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/club_detail/${item.club_id}`}>
                                                {item.club_id || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubName"]}
                                        dataIndex="club_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["role"]}
                                        dataIndex=""
                                        render={(item) => {
                                            let role = this.state.roleList.find((item2) => item2.value === item.level)
                                            let label = role ? role.label : ""
                                            switch (item.level) {
                                                case 100:
                                                    return <Tag color="blue">{label}</Tag>
                                                case 10:
                                                    return <Tag color="purple">{label}</Tag>
                                                case 9:
                                                    return <Tag color="red">{label}</Tag>
                                                case 8:
                                                    return <Tag color="magenta">{label}</Tag>
                                                case 7:
                                                    return <Tag color="volcano">{label}</Tag>
                                                case 6:
                                                    return <Tag color="orange">{label}</Tag>
                                                case 5:
                                                    return <Tag color="gold">{label}</Tag>
                                                case 1:
                                                    return <Tag>{label}</Tag>
                                            }
                                        }}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["superPlayerId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            this.state.playerInfo.parent_user_id ? <Link
                                                to={`/player_detail/${item.parent_user_id}/${item.club_id}`}
                                            >
                                                {item.parent_user_id || ''}
                                            </Link>
                                                :
                                                '/'
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["superPlayerName"]}
                                        dataIndex=""
                                        render={(item) => (
                                            this.state.playerInfo.parent_user_name || '/'
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["playerChip"]}
                                        dataIndex="chips"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["counterPoint"]}
                                        dataIndex="point"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["counterDiamond"]}
                                        dataIndex="diamond"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["lowerCounterTotalIntergral"]}
                                        dataIndex="underline_points"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["lowerProxyNumber"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    this.handleShow("underlineProxy", item)
                                                }
                                            >
                                                {item.underline_agents}
                                            </Button>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["lowerPlayerNumber"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Button
                                                type="link"
                                                onClick={() =>
                                                    this.handleShow("underlinePlayer", item)
                                                }
                                            >
                                                {item.underline_players}
                                            </Button>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["operation"]}
                                        dataIndex=""
                                        fixed={isMobileDevice() ? false : "right"}
                                        width={120}
                                        render={(item) => (
                                            <Button
                                                onClick={() => this.handleShow("proportion", item)}
                                            >
                                                {this.props.language["proportionData"]}
                                            </Button>
                                        )}
                                    />
                                </Table>
                            </Card>

                            {/* 数据 */}
                            <Card
                                className="mt10"
                                title={<h2>{this.props.language["data"]}</h2>}
                                type="inner"
                            >
                                <div className='container-header p0'>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={this.props.language["dataType"]}
                                        value={this.state.gameQueryParams.kind}
                                        onChange={(value) =>
                                            this.handleSetQueryParamsData("kind", value, "game")
                                        }
                                    >
                                        <Select.Option
                                            value={0}
                                            disabled={this.state.playerInfo.level === 1}
                                        >
                                            {this.props.language["proxyData"]}
                                        </Select.Option>
                                        <Select.Option value={1}>
                                            {this.props.language["gameData"]}
                                        </Select.Option>
                                    </Select>
                                    <DatePicker.RangePicker
                                        value={this.state.gameQueryParams.date}
                                        onChange={(e) =>
                                            this.handleSetQueryParamsData("date", e, "game")
                                        }
                                    />
                                </div>
                                <Table
                                    className='mt10'
                                    dataSource={this.state.gameData}
                                    pagination={false}
                                    loading={this.state.gameLoading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                    bordered
                                    size="small"
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["handNumber"]}
                                        dataIndex="hands_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["gameProfit"]}
                                        dataIndex="profit_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["serviceFeeContribution"]}
                                        dataIndex="fee_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insuranceContribution"]}
                                        dataIndex="ins_profit_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insuranceInvestmentAmount"]}
                                        dataIndex="ins_buy_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["cowboyContribution"]}
                                        dataIndex="cb_profit_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["cowboyBettingAmount"]}
                                        dataIndex="cb_buy_in_sum"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["joinTableNumberStatistics"]}
                                        dataIndex="match_sum_detail"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["handNumberStatistics"]}
                                        dataIndex="hands_sum_detail"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["profitStatistics"]}
                                        dataIndex="profit_sum_detail"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["serviceFeeStatistics"]}
                                        dataIndex="fee_sum_detail"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insuranceStatistics"]}
                                        dataIndex="ins_profit_sum_detail"
                                    />
                                </Table>
                            </Card>

                            {/* 亏损设置 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>
                                            {this.props.language["lossSetting"]}
                                        </h2>
                                        <div>
                                            <Button
                                                type="primary"
                                                ghost
                                                onClick={() => this.handleShow("editLossLimit")}
                                            >
                                                {this.props.language["edit"]}
                                            </Button>
                                        </div>
                                    </Row>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    {/* 日亏损限制 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                {this.state.playerInfo.loss_info && (
                                                    <>
                                                        {this.state.playerInfo.loss_info.no_day_limit ?
                                                            <h2 style={{ lineHeight: '45px' }}>无限制</h2>
                                                            :
                                                            <Statistic
                                                                value={Number(
                                                                    this.state.playerInfo.loss_info.day_loss_limit || 0
                                                                )}
                                                            />
                                                        }
                                                        <p className="label">
                                                            {this.props.language["dayLossLimit"]}
                                                            {this.props.getLanguage(
                                                                "remainingQuota",
                                                                this.state.playerInfo.loss_info.no_day_limit ? '无限制' : this.state.playerInfo.loss_info.day_loss_quota || 0
                                                            )}
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* 周亏损限制 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                {this.state.playerInfo.loss_info && (
                                                    <>
                                                        {this.state.playerInfo.loss_info.no_week_limit ?
                                                            <h2 style={{ lineHeight: '45px' }}>无限制</h2>
                                                            :
                                                            <Statistic
                                                                value={Number(
                                                                    this.state.playerInfo.loss_info.week_loss_limit || 0
                                                                )}
                                                            />
                                                        }
                                                        <p className="label">
                                                            {this.props.language["weekLossLimit"]}
                                                            {this.props.getLanguage(
                                                                "remainingQuota",
                                                                this.state.playerInfo.loss_info.no_week_limit ? '无限制' : this.state.playerInfo.loss_info.week_loss_quota || 0
                                                            )}
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 牌局屏蔽 */}
                            {(Cookie.get("identityType") === "union" ||
                                Cookie.get("identityType") === "union_vip" ||
                                Cookie.get("identityType") === "union_admin_service" ||
                                Cookie.get("identityType") === "super_union" ||
                                Cookie.get("identityType") === "super_union_vip" ||
                                Cookie.get("identityType") === "super_union_admin_service") && (
                                    <Card
                                        className="mt10"
                                        title={
                                            <h2>
                                                {this.props.language["shieldGamble"]}
                                            </h2>
                                        }
                                        type="inner"
                                    >
                                        <Row gutter={10}>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["nlh"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.nlh &&
                                                                this.state.handCardConfig.nlh.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(1, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.nlh &&
                                                                this.state.handCardConfig.nlh.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(1, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.nlh &&
                                                                this.state.handCardConfig.nlh.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(1, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>{this.props.language["bbLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.nlh &&
                                                                this.state.handCardConfig.nlh.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(1, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["plo"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.plo &&
                                                                this.state.handCardConfig.plo.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(4, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.plo &&
                                                                this.state.handCardConfig.plo.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(4, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.plo &&
                                                                this.state.handCardConfig.plo.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(4, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>{this.props.language["bbLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.plo &&
                                                                this.state.handCardConfig.plo.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(4, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["six"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["anteLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.six_plus &&
                                                                this.state.handCardConfig.six_plus.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(2, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["anteLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.six_plus &&
                                                                this.state.handCardConfig.six_plus.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(2, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["anteLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.six_plus &&
                                                                this.state.handCardConfig.six_plus.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(2, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" >
                                                        <p>{this.props.language["anteLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.six_plus &&
                                                                this.state.handCardConfig.six_plus.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(2, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row gutter={10}>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["ofc"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["scoreLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.ofc &&
                                                                this.state.handCardConfig.ofc.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(6, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["scoreLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.ofc &&
                                                                this.state.handCardConfig.ofc.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(6, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["scoreLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.ofc &&
                                                                this.state.handCardConfig.ofc.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(6, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>{this.props.language["scoreLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.ofc &&
                                                                this.state.handCardConfig.ofc.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(6, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["aof"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.aof &&
                                                                this.state.handCardConfig.aof.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(8, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.aof &&
                                                                this.state.handCardConfig.aof.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(8, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["bbLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.aof &&
                                                                this.state.handCardConfig.aof.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(8, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>{this.props.language["bbLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.aof &&
                                                                this.state.handCardConfig.aof.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(8, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["cowboy"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>Cowboy</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.cowboy &&
                                                                this.state.handCardConfig.cowboy
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(3, "", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row gutter={10}>
                                            <Col span={isMobileDevice() ? 24 : 8}>
                                                <Card
                                                    title={<h3>{this.props.language["mtt"]}</h3>}
                                                    type="inner"
                                                    className="mb10"
                                                >
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["feeMatch"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.mtt &&
                                                                this.state.handCardConfig.mtt.free
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(5, "free", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["applyLevel1"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.mtt &&
                                                                this.state.handCardConfig.mtt.micro
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(5, "micro", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["applyLevel2"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.mtt &&
                                                                this.state.handCardConfig.mtt.small
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(5, "small", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                        <p>{this.props.language["applyLevel3"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.mtt &&
                                                                this.state.handCardConfig.mtt.middle
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(5, "middle", value)
                                                            }
                                                        />
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="space-between">
                                                        <p>{this.props.language["applyLevel4"]}</p>
                                                        <Switch
                                                            checked={
                                                                this.state.handCardConfig.mtt &&
                                                                this.state.handCardConfig.mtt.high
                                                            }
                                                            onChange={(value) =>
                                                                this.handleUpdateConfig(5, "high", value)
                                                            }
                                                        />
                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}
                        </Col>

                        {/* 右侧 */}
                        <Col span={isMobileDevice() ? 24 : 12}>
                            {/* 数据记录 */}
                            <Card
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>{this.props.language["dataRecord"]}</h2>
                                        <Button
                                            type="default"
                                            icon="arrow-down"
                                            className="btn-yellow-ghost"
                                            loading={this.state.dataRecordExportLoading}
                                            onClick={() => this.handleShow('exportDataRecord')}
                                        >
                                            {this.props.language["exportDataRecord"]}
                                        </Button>
                                    </Row>
                                }
                                type="inner"
                            >
                                <Tabs>
                                    {/* 积分记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["intergralRecord"]}
                                        key="integral"
                                    >
                                        <div className='container-header p0'>
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                placeholder={this.props.language["dataType"]}
                                                value={this.state.integralQueryParams.kind}
                                                onChange={(value) =>
                                                    this.handleSetQueryParamsData(
                                                        "kind",
                                                        value,
                                                        "integral"
                                                    )
                                                }
                                            >
                                                <Select.Option
                                                    value={0}
                                                    disabled={this.state.playerInfo.level === 1}
                                                >
                                                    {this.props.language["proxyData"]}
                                                </Select.Option>
                                                <Select.Option value={1}>
                                                    {this.props.language["gameData"]}
                                                </Select.Option>
                                            </Select>
                                        </div>
                                        <Table
                                            className="mt10"
                                            dataSource={this.state.integralData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.integralQueryParams.page,
                                                pageSize: this.state.integralQueryParams.limit,
                                                total: this.state.integralQueryParams.total,
                                            }}
                                            loading={this.state.integralLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "integral")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="log_time"
                                            />
                                            {this.state.integralQueryParams.kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title="MID"
                                                    dataIndex="mid"
                                                />
                                            )}
                                            {this.state.integralQueryParams.kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title={this.props.language["clubId"]}
                                                    dataIndex=""
                                                    render={(item) => (
                                                        <Link to={`/club_detail/${item.club_id}`}>
                                                            {item.club_id || ''}
                                                        </Link>
                                                    )}
                                                />
                                            )}
                                            {this.state.integralQueryParams.kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title={this.props.language["clubName"]}
                                                    dataIndex="club_name"
                                                />
                                            )}
                                            {this.state.integralQueryParams.kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title={this.props.language["unionId"]}
                                                    dataIndex=""
                                                    render={(item) => (
                                                        <Link to={`/union_detail/${item.union_id}`}>
                                                            {item.union_id || ''}
                                                        </Link>
                                                    )}
                                                />
                                            )}
                                            {this.state.integralQueryParams.kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title={this.props.language["unionName"]}
                                                    dataIndex="union_name"
                                                />
                                            )}
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["counterPoint"]}
                                                dataIndex="point"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["balance"]}
                                                dataIndex="balance"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["type"]}
                                                dataIndex="log_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["remark"]}
                                                dataIndex="desc"
                                            />
                                        </Table>
                                    </Tabs.TabPane>

                                    {/* 钻石记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["diamondLog"]}
                                        key="diamond"
                                    >
                                        <Table
                                            dataSource={this.state.diamondData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.diamondQueryParams.page,
                                                pageSize: this.state.diamondQueryParams.limit,
                                                total: this.state.diamondQueryParams.total,
                                            }}
                                            loading={this.state.diamondLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "diamond")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="log_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["type"]}
                                                dataIndex="log_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["amount"]}
                                                dataIndex="diamond"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["balance"]}
                                                dataIndex="balance"
                                            />
                                        </Table>
                                    </Tabs.TabPane>

                                    {/* 柜台钻石记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["counterDiamondRecord"]}
                                        key="counterDiamond"
                                    >
                                        <Table
                                            dataSource={this.state.counterDiamondData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.counterDiamondQueryParams.page,
                                                pageSize: this.state.counterDiamondQueryParams.limit,
                                                total: this.state.counterDiamondQueryParams.total,
                                            }}
                                            loading={this.state.counterDiamondLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "counterDiamond")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="log_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["type"]}
                                                dataIndex="log_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["amount"]}
                                                dataIndex="diamond"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["balance"]}
                                                dataIndex="balance"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/club_detail/${item.club_id}`}>{item.club_id || ''}</Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubName"]}
                                                dataIndex="club_name"
                                            />
                                        </Table>
                                    </Tabs.TabPane>

                                    {/* 登录记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["loginRecord"]}
                                        key="login"
                                    >
                                        <Table
                                            dataSource={this.state.loginData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.loginQueryParams.page,
                                                pageSize: this.state.loginQueryParams.limit,
                                                total: this.state.loginQueryParams.total,
                                            }}
                                            loading={this.state.loginLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "login")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["loginTime"]}
                                                dataIndex="login_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clientVersion"]}
                                                dataIndex="version"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["channelNumber"]}
                                                dataIndex="channel"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["networkType"]}
                                                dataIndex="network"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["systemYype"]}
                                                dataIndex="os_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["unitType"]}
                                                dataIndex="device_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["loginIp"]}
                                                dataIndex="ip"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["imei"]}
                                                dataIndex="imei"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["macAddress"]}
                                                dataIndex="mac"
                                            />
                                        </Table>
                                    </Tabs.TabPane>

                                    {/* 操作记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["operateRecord"]}
                                        key="operate"
                                    >
                                        <div className='container-header p0'>
                                            <DatePicker.RangePicker
                                                value={this.state.operateQueryParams.date}
                                                onChange={(e) =>
                                                    this.handleSetQueryParamsData("date", e, "operate")
                                                }
                                            />
                                        </div>
                                        <Table
                                            className="mt10"
                                            dataSource={this.state.operateData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.operateQueryParams.page,
                                                pageSize: this.state.operateQueryParams.limit,
                                                total: this.state.operateQueryParams.total,
                                            }}
                                            loading={this.state.operateLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "operate")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["unionId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/union_detail/${item.union_id}`}>
                                                        {item.union_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["unionName"]}
                                                dataIndex="union_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/club_detail/${item.club_id}`}>
                                                        {item.club_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubName"]}
                                                dataIndex="club_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonId"]}
                                                dataIndex="opt_uid"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonName"]}
                                                dataIndex="opt_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonRole"]}
                                                dataIndex="opt_role_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationType"]}
                                                dataIndex="reason"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationedPlayerId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/player_detail/${item.user_id}/${item.club_id}`}>
                                                        {item.user_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationedPlayerName"]}
                                                dataIndex="user_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationDetail"]}
                                                dataIndex="detail"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="tunix"
                                            />
                                        </Table>
                                    </Tabs.TabPane>
                                </Tabs>
                            </Card>

                            {/* 牌局记录 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>{this.props.language["tableRoundRecordList"]}</h2>
                                        <Button
                                            type="default"
                                            icon="arrow-down"
                                            className="btn-yellow-ghost"
                                            loading={this.state.gambleRecordExportLoading}
                                            onClick={this.handleExportGambleRecord}
                                        >
                                            {this.props.language["exportGambleRecord"]}
                                        </Button>
                                    </Row>
                                }
                                type="inner"
                            >
                                <div className='container-header p0'>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={this.props.language["gameTypePlaceholder"]}
                                        value={this.state.roundQueryParams.game_kind}
                                        onChange={(value) =>
                                            this.handleSetQueryParamsData("game_kind", value, "round")
                                        }
                                    >
                                        {this.state.kindList.map((item, index) => (
                                            <Select.Option value={item.value} key={index}>
                                                {item.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                    <DatePicker.RangePicker
                                        value={this.state.roundQueryParams.date}
                                        onChange={(e) =>
                                            this.handleSetQueryParamsData("date", e, "round")
                                        }
                                    />
                                </div>

                                {/* NLH, 6+, PLO, OFC, AOF */}
                                {(this.state.roundQueryParams.game_kind === 1 ||
                                    this.state.roundQueryParams.game_kind === 2 ||
                                    this.state.roundQueryParams.game_kind === 4 ||
                                    this.state.roundQueryParams.game_kind === 6 ||
                                    this.state.roundQueryParams.game_kind === 8) && (
                                        <Table
                                            className='mt10'
                                            dataSource={this.state.roundData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.roundQueryParams.page,
                                                pageSize: this.state.roundQueryParams.limit,
                                                total: this.state.roundQueryParams.total,
                                            }}
                                            loading={this.state.roundLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "round")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["gambleId"]}
                                                dataIndex="mid"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["openRole"]}
                                                dataIndex="opened_by"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["startTime"]}
                                                dataIndex="begin_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["endTime"]}
                                                dataIndex="end_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["level"]}
                                                dataIndex="level"
                                            />
                                            {this.state.roundQueryParams.game_kind === 1 && (
                                                <Table.Column
                                                    align="center"
                                                    title={this.props.language["squidGame"]}
                                                    dataIndex=""
                                                    render={(item) =>
                                                        item.squid_conf ? (
                                                            <p>
                                                                {this.state.squidTypeList.find(
                                                                    (item2) => item2.value === item.squid_conf.mode
                                                                ) ?
                                                                    this.state.squidTypeList.find(
                                                                        (item2) =>
                                                                            item2.value === item.squid_conf.mode
                                                                    ).label : ''}
                                                                ({item.squid_conf.bb / 2}BB)
                                                            </p>
                                                        ) : (
                                                            this.props.language["no"]
                                                        )
                                                    }
                                                />
                                            )}
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["openInsurance"]}
                                                dataIndex="insurance_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["profit"]}
                                                dataIndex="profit"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["serviceFee"]}
                                                dataIndex="fee"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["insuranceProfit"]}
                                                dataIndex="ins_profit"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["buyIn"]}
                                                dataIndex="buy_in"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["handNumber"]}
                                                dataIndex="hands"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["insureTimes"]}
                                                dataIndex="ins_num"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["sumInsured"]}
                                                dataIndex="ins_buy"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operation"]}
                                                dataIndex=""
                                                fixed={isMobileDevice() ? false : "right"}
                                                width={120}
                                                render={(item) => (
                                                    <Button
                                                        type="default"
                                                        onClick={() => this.handleShow("handCard", item)}
                                                    >
                                                        {this.props.language["handDetail"]}
                                                    </Button>
                                                )}
                                            />
                                        </Table>
                                    )}

                                {/* Cowboy */}
                                {this.state.roundQueryParams.game_kind === 3 && (
                                    <Table
                                        className="mt10"
                                        dataSource={this.state.roundData}
                                        pagination={{
                                            showTotal: (total) =>
                                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                            showQuickJumper: true,
                                            showSizeChanger: true,
                                            size: isMobileDevice() ? 'small' : '',
                                            pageSizeOptions: ["10", "20", "30", "40"],
                                            current: this.state.roundQueryParams.page,
                                            pageSize: this.state.roundQueryParams.limit,
                                            total: this.state.roundQueryParams.total,
                                        }}
                                        loading={this.state.roundLoading}
                                        onChange={(pagination) =>
                                            this.hanldeChangePage(pagination, "round")
                                        }
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                        bordered
                                        size="small"
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["profit"]}
                                            dataIndex="profit_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["betAmount"]}
                                            dataIndex="buy_in_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["handNumber"]}
                                            dataIndex="hands_sum"
                                        />
                                    </Table>
                                )}

                                {/* MTT */}
                                {this.state.roundQueryParams.game_kind === 5 && (
                                    <Table
                                        className="mt10"
                                        dataSource={this.state.roundData}
                                        pagination={{
                                            showTotal: (total) =>
                                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                            showQuickJumper: true,
                                            showSizeChanger: true,
                                            size: isMobileDevice() ? 'small' : '',
                                            pageSizeOptions: ["10", "20", "30", "40"],
                                            current: this.state.roundQueryParams.page,
                                            pageSize: this.state.roundQueryParams.limit,
                                            total: this.state.roundQueryParams.total,
                                        }}
                                        loading={this.state.roundLoading}
                                        onChange={(pagination) =>
                                            this.hanldeChangePage(pagination, "round")
                                        }
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                        bordered
                                        size="small"
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["gambleId"]}
                                            dataIndex="mid"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["openRole"]}
                                            dataIndex="opened_by"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["startTime"]}
                                            dataIndex="begin_time"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["endTime"]}
                                            dataIndex="end_time"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["enterFee"]}
                                            dataIndex="entry_fee"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["rebuyTime"]}
                                            dataIndex="rebuy_times"
                                        />
                                        <Table.Column
                                            align="center"
                                            title="Addon"
                                            dataIndex="addon"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["rank"]}
                                            dataIndex="rank"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["award"]}
                                            dataIndex="bonus"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["operation"]}
                                            dataIndex=""
                                            fixed={isMobileDevice() ? false : "right"}
                                            width={120}
                                            render={(item) => (
                                                <Button
                                                    type="default"
                                                    onClick={() => this.handleShow("handCard", item)}
                                                >
                                                    {this.props.language["handDetail"]}
                                                </Button>
                                            )}
                                        />
                                    </Table>
                                )}
                            </Card>
                        </Col>
                    </Row>

                    {/* 表单弹窗 */}
                    <FormModal
                        {...this.props}
                        visible={this.state.show}
                        type={this.state.type}
                        title={this.state.title}
                        formData={this.state.formData}
                        onOk={this.handleSubmit}
                        onCancel={this.handleClose}
                        wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                    />

                    {/* 俱乐部其他信息弹窗 */}
                    <ClubOtherInfoModal
                        {...this.props}
                        visible={this.state.showClubOtherInfo}
                        type={this.state.type}
                        title={this.state.title}
                        playerInfo={this.state.playerInfo}
                        roleList={this.state.roleList}
                        onCancel={() => this.setState({ showClubOtherInfo: false })}
                    />

                    {/* 手牌详情弹窗 */}
                    <HandCardModal
                        {...this.props}
                        visible={this.state.showDetail}
                        type={this.state.type}
                        title={this.state.title}
                        loading={this.state.detailLoading}
                        roundQueryParams={this.state.roundQueryParams}
                        detailQueryParams={this.state.detailQueryParams}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            current: this.state.detailQueryParams.page,
                            pageSize: this.state.detailQueryParams.limit,
                            total: this.state.detailQueryParams.total,
                            size: isMobileDevice() ? 'small' : '',
                        }}
                        tableList={this.state.tableList}
                        selectedData={this.state.selectedData}
                        handCardData={this.state.handCardData}
                        handleSetQueryParamsData={this.handleSetQueryParamsData}
                        onCancel={() => this.setState({ showDetail: false })}
                        onChange={(pagination) =>
                            this.hanldeChangePage({ current: pagination }, "handCard")
                        }
                    />
                </div>
            </Spin>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 发放回收钻石，筹码 */}
                            {(
                                this.props.type === "sendJetton" ||
                                this.props.type === "recycleJetton" ||
                                this.props.type === "sendIntegral" ||
                                this.props.type === "recycleIntegral" ||
                                this.props.type === "sendDiamond" ||
                                this.props.type === "recycleDiamond"
                            ) && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator("amount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"],
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 编辑亏损限额 */}
                            {this.props.type === "editLossLimit" && (
                                <>
                                    <Form.Item label={this.props.language["dayLossLimit"]}>
                                        {getFieldDecorator("no_day_limit", {
                                            initialValue: this.props.formData.no_day_limit,
                                            valuePropName: "checked",
                                        })(
                                            <Switch />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('no_day_limit') &&
                                        <>
                                            <Form.Item label={this.props.language["dayLossLimitQuota"]}>
                                                {getFieldDecorator("day_limit", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.language["dayLossLimitQuotaVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.day_limit,
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["dayLossLimitQuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item label={`${this.props.language["dayRemainingRuota"]}（${Number(this.props.formData.add_day_left) + Number(getFieldValue('add_day_left') || 0)}）`}>
                                                {getFieldDecorator("add_day_left", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["dayRemainingRuotaVerify"],
                                                        },
                                                    ],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["dayRemainingRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                        </>
                                    }
                                    <Form.Item label={this.props.language["weekLossLimit"]}>
                                        {getFieldDecorator("no_week_limit", {
                                            initialValue: this.props.formData.no_week_limit,
                                            valuePropName: "checked",
                                        })(
                                            <Switch />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('no_week_limit') &&
                                        <>
                                            <Form.Item label={this.props.language["weekLossLimitRuota"]}>
                                                {getFieldDecorator("week_limit", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.language["weekLossLimitRuotaVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.week_limit,
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["weekLossLimitRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item label={`${this.props.language["weekRemainingRuota"]}（${Number(this.props.formData.add_week_left) + Number(getFieldValue('add_week_left') || 0)}）`}>
                                                {getFieldDecorator("add_week_left", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["weekRemainingRuotaVerify"],
                                                        },
                                                    ],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["weekRemainingRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                        </>
                                    }
                                </>
                            )}

                            {/* 导出数据记录 */}
                            {this.props.type === "exportDataRecord" && (
                                <>
                                    <Form.Item label={this.props.language["timeRange"]}>
                                        {getFieldDecorator("date", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["timeRangeVerify"],
                                                },
                                            ],
                                        })(
                                            <DatePicker.RangePicker />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 俱乐部其他信息弹窗
 */
class ClubOtherInfoModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={false}
            >
                <div className="container-content">
                    {/* 下线代理 */}
                    {this.props.type === "underlineProxy" && (
                        <Table
                            className="mt10"
                            dataSource={this.props.playerInfo.underline_agents_list}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                            bordered
                            size="small"
                            pagination={false}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["playerId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link
                                        to={`/player_detail/${item.uid}/${this.props.playerInfo.club_id}`}
                                    >
                                        {item.uid || ''}
                                    </Link>
                                )}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["playerName"]}
                                dataIndex="name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["role"]}
                                dataIndex=""
                                render={(item) =>
                                    this.props.roleList.find((role) => role.value === item.level)
                                        ? this.props.roleList.find(
                                            (role) => role.value === item.level
                                        ).label
                                        : ""
                                }
                            />
                        </Table>
                    )}

                    {/* 下线玩家 */}
                    {this.props.type === "underlinePlayer" && (
                        <Table
                            className="mt10"
                            dataSource={this.props.playerInfo.underline_players_list}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                            bordered
                            size="small"
                            pagination={false}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["playerId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link
                                        to={`/player_detail/${item.uid}/${this.props.playerInfo.club_id}`}
                                    >
                                        {item.uid || ''}
                                    </Link>
                                )}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["playerName"]}
                                dataIndex="name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["role"]}
                                dataIndex=""
                                render={(item) =>
                                    this.props.roleList.find((role) => role.value === item.level)
                                        ? this.props.roleList.find(
                                            (role) => role.value === item.level
                                        ).label
                                        : ""
                                }
                            />
                        </Table>
                    )}

                    {/* 占成数据 */}
                    {this.props.type === "proportion" && (
                        <Table
                            className="mt10"
                            dataSource={[this.props.playerInfo.ratio_mod]}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                            bordered
                            size="small"
                            pagination={false}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["serviceFeeSharingRatio"]}
                                dataIndex=""
                                render={(item) => item.fee_ratio + "%"}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceSharingRatio"]}
                                dataIndex=""
                                render={(item) => item.ins_ratio + "%"}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceMode"]}
                                dataIndex=""
                                render={(item) =>
                                    item.ins_mod === 1 ? this.props.language["risk"] : "EV"
                                }
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["cowboySharingRatio"]}
                                dataIndex=""
                                render={(item) => item.cowboy_ratio + "%"}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["cowboyMode"]}
                                dataIndex=""
                                render={(item) =>
                                    item.cowboy_mod === 1 ? this.props.language["risk"] : "EV"
                                }
                            />
                        </Table>
                    )}
                </div>
            </Modal>
        );
    }
}

/**
 * 手牌详情弹窗
 */
class HandCardModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                        {this.props.roundQueryParams.game_kind === 5 && (
                            <>
                                <Select
                                    className="mr20"
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder={
                                        this.props.language["currentGambleTablePlaceholder"]
                                    }
                                    value={this.props.detailQueryParams.tid}
                                    onChange={(value) =>
                                        this.props.handleSetQueryParamsData(
                                            "tid",
                                            value,
                                            "handCard"
                                        )
                                    }
                                >
                                    {this.props.tableList.map((item, index) => (
                                        <Select.Option value={item.tid} key={index}>
                                            {this.props.language["gambleTable"]}
                                            {item.tid}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </>
                        )}
                    </>
                )}
                <InputNumber
                    style={{ width: 220 }}
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["playerIdPlaceholder"]}
                    value={this.props.detailQueryParams.uid}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("uid", value, "handCard")
                    }
                />
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={
                    this.props.type === "handCard" ? handCardTitle : this.props.title
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination

                        showQuickJumper
                        {...this.props.pagination}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        size={isMobileDevice() ? 'small' : ''}
                        onChange={this.props.onChange}
                    />
                }
            >
                <div className="container-content">
                    {/* 手牌详情 */}
                    {this.props.type === "handCard" && (
                        <Spin spinning={this.props.loading}>
                            {this.props.handCardData.id && (
                                <>
                                    {/* OFC */}
                                    {this.props.roundQueryParams.game_kind === 6 && (
                                        <HandDetailOfc
                                            {...this.props}
                                            handCardData={this.props.handCardData}
                                            searchPlayer={{
                                                uid1: this.props.detailQueryParams.uid,
                                            }}
                                        />
                                    )}

                                    {/* NLH, 6+, PLO, AOF, MTT */}
                                    {this.props.roundQueryParams.game_kind !== 6 && (
                                        <HandDetail
                                            {...this.props}
                                            handCardData={this.props.handCardData}
                                            squidConf={this.props.selectedData.squid_conf}
                                            searchPlayer={{
                                                uid1: this.props.detailQueryParams.uid,
                                            }}
                                        />
                                    )}
                                </>
                            )}

                            {/* 暂无数据 */}
                            {!this.props.handCardData.id && (
                                <>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                </>
                            )}
                        </Spin>
                    )}
                </div>
            </Modal>
        );
    }
}
